// extracted by mini-css-extract-plugin
export default {"closeCustomModal":"closeCustomModal__hibUj","title":"title__cLHfb","details":"details__2sdZm","buttons":"buttons__6TYSk"};